import { Config } from "../../../configurations/config";
export const ViewLeaveApplication_API = {
  GetLeaveTypes: `${Config.server_url}${Config.api_prefix}/Leave/LeaveTypes`,
  GetDefaultUnreviewedLeaves_API: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications?SortBy=applied_date_desc`,
  GetUnreviewedLeaves_API: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications?`,
  GetUnreviewedLeavesApplicationDetail: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications`,
  PatchReviewLeaveApplication: `${Config.server_url}${Config.api_prefix}/Leave/UnreviewedLeaveApplications`,
  GetSupervisorEmployees_API: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
  GetLeaveStatusType_API: `${Config.server_url}${Config.api_prefix}/Leave/GetLeaveStatusTypes`,
  GetLeaves_API: `${Config.server_url}${Config.api_prefix}/Leave/GetLeavesForSuperAdmin`,
  GetExportAttendance_API: `${Config.server_url}${Config.api_prefix}/Leave/GetLeavesForSuperAdmin/ExportToExcel`,

  //----- Detail Screen-----//
  GetLeavesForSuperAdmin: `${Config.server_url}${Config.api_prefix}/Leave/GetLeavesForSuperAdmin`,
  GetReviewedLeaves_API: `${Config.server_url}${Config.api_prefix}/Leave/ReviewedLeaveApplications?`,
  GetReviewedLeaveById: `${Config.server_url}${Config.api_prefix}/Leave/ReviewedLeaveApplications`,
  GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
  PutSuperAdminComments: `${Config.server_url}${Config.api_prefix}/Leave/GetLeavesForSuperAdmin`,
};
